export function parseGeoCoderResult(data) {
  if (!data.suggestions || !data.suggestions.length) {
    return [];
  }

  return data.suggestions.map(d => {
    d.label = d.label.replace('Deutschland, ', '');
    return d;
  }).filter(d => d.label !== '' && d.label !== 'Deutschland');
}

export function getSuggestUrl(opts) {
  return `https://autocomplete.geocoder.cit.api.here.com/6.2/suggest.json?query=${opts.query}&app_id=${opts.app_id}&app_code=${opts.app_code}&country=${opts.country}&language=de&prox=${opts.center.join(',')},${opts.radius}&beginHighlight=<strong>&endHighlight=</strong>`;
}

export function getGeoCodingUrl(opts) {
  return `https://geocoder.cit.api.here.com/6.2/geocode.json?locationid=${opts.locationId}&jsonattributes=1&gen=9&app_id=${opts.app_id}&app_code=${opts.app_code}`;
}

export default {
  parseGeoCoderResult,
  getSuggestUrl,
  getGeoCodingUrl
}